import React from 'react';
import { cn } from '../utils/cn';
import './TitleAndMetadataBar.css';

/**
 * CARD TITLE AND METADATA BAR — NOT the page title/subtitle/breadcrumb component.
 * This is a generic top-of-card bar: left-aligned elements and right-aligned
 * elements, each separated by a full-height vertical divider (same divider
 * mechanism and line color as SectionsCard's column dividers), with one
 * horizontal divider under the whole bar. Callers decide what each element
 * renders (title, counts, pills, buttons, ...) — this component only owns
 * the divider/layout mechanics. Used inside cards/sections, not at the page level.
 *
 * Ported from the reporting UI, restyled with plain CSS against tokens.css.
 *
 * @param {React.ReactNode[]} leftElements
 * @param {React.ReactNode[]} rightElements
 */
export default function TitleAndMetadataBar({ leftElements = [], rightElements = [], className }) {
  const left = leftElements.filter(Boolean);
  const right = rightElements.filter(Boolean);

  return (
    <div className={cn('tmb', className)}>
      <div className="tmb-group tmb-group--left">
        {left.map((element, index) => (
          <div key={index} className="tmb-cell tmb-cell--shrinkable">{element}</div>
        ))}
      </div>
      {right.length > 0 ? (
        <div className="tmb-group tmb-group--right">
          {right.map((element, index) => (
            <div key={index} className="tmb-cell">{element}</div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
